import { routeFileSelector } from '@/utilz';
import WithFilter from '@/views/screens/common/WithFilter';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import SaversShipmentContent from './shipment/SaversShipmentContent';
import SaversShipmentFilters from './shipment/SaversShipmentFilters';
import SaversShipmentFooter from './shipment/SaversShipmentFooter';

const SaversShipment = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <>
      <WithFilter
        filterElement={<SaversShipmentFilters />}
        contentElement={<SaversShipmentContent />}
        filterTitle={t('translation:default.fields.filter')}
        pageTitle={t('translation:shipment.header.title')}
        footerContent={<SaversShipmentFooter />}
      />
    </>
  );
};

export default memo(SaversShipment);
